import { Rules } from '../../constants/TransformationRulesConstants';

var dateFormat = require('dateformat');

export const objectsConstants = {
    USER: {
        user_name: '',
        email: '',
        first_name: '',
        last_name: '',
        password: '',
        confirm_password: '',
        role_id: '',
    },
    PERMISSION: {
        name: '',
        permission_type: '',
        is_menu: false,
        label: '',
        icon: '',
        description: '',
        parent_label: '',
        order: '',
        path: '',
        module_id: ''
    },

    list: {
        title: '',
        list_type_id: '',
        list_type_field: '',
        parent_id: '',
        parent: '',
    },
    dataTypeList: [
        { value: "datetime", label: "Date" },
        { value: "url", label: "URL" },
        { value: "integer", label: "Integer" },
        { value: "float", label: "Float" },
        { value: "string", label: "Varchar String(0 - 255)" },
        { value: "text", label: "Text String(0 - 65535)" },
    ],
    list_type: {
        title: '',
    },
    brand_product_attributes: {
        "title": "",
        "db_column": "",
        "show_on_grid": false,
        "grid_label": "",
        "sample_value": "",
        "data_type": "",
        "default_value": "",
        "editable": false,
        "import_order": "1",
        "exportable": false,
        "searchable": false,
        "is_quantity_attribute": false,
        "is_product_key": false,
        default_value_type: null,
        // "unique_columns": [],//add title value
    },
    brand_order_attributes: {
        order: '',
        title: '',
        cart_label: '',
        sample_value: '',
        data_type: 'integer',
        show_on_cart: true,
        editable: false,
        searchable: false,
        is_quantity_attribute: false,
        adjust_product_attribute: '',
    },
    brand_order_attribute_default: {
        order: '',
        title: 'Ordered Qty',
        db_column: 'ordered_qty',
        cart_label: 'Ordered Qty',
        sample_value: 110,
        data_type: 'integer',
        show_on_cart: true,
        editable: false,
        searchable: false,
        is_quantity_attribute: true,
        adjust_product_attribute: '',
    },
    data_definition_filetypes: ['text', 'csv'],
    DEFAULT_DATE_OPTIONS: [
        {
            value: '',
            label: 'None'
        },
        {
            value: 'now',
            label: 'Now'
        },
        {
            value: 'pick_date',
            label: 'Pick Date'
        },
    ],
    data_definition_formats: [
        {
            key: 'CSV',
            label: 'CSV File'
        },
        {
            key: 'EXCEL',
            label: 'Excel File'
        },
        {
            key: 'TEXT',
            label: 'Text Delimited File'
        },
        {
            key: 'FIXED_LENGTH',
            label: 'Fixed Length Text File'
        },
        {
            key: 'rest',
            label: 'RESTFul API'
        }
    ],
    LOOKUP_DEFINITION_FORMATS: [
        {
            key: 'CSV',
            label: 'CSV File'
        },
        {
            key: 'EXCEL',
            label: 'Excel File'
        },
    ],
    data_definition_delimiters: [
        {
            key: ',',
            label: ', (Comma)'
        },
        {
            key: '|',
            label: '| (Pipe)'
        },
        {
            key: '\t',
            label: 'Tab (Tab space)'
        }
    ],
    user: {
        user_name: '',
        password: '',
        password_confirmation: '',
        customer: {
            title: '',
            contact: {
                first_name: '',
                last_name: '',
                email: '',
                type_id: '',
                customer_id: ''
            },
            user: {
                user_name: '',
                password: '',
                password_confirmation: '',
            },
            address: {
                contact_name: "",
                line1: "",
                country_id: "",
                city: "",
                region_id: "",
                zip_post_code: ""
            }
        },
        address: {
            line1: '',
            region_id: '',
            country_id: '',
            city: '',
            zip_post_code: '',
        },
        component_name: 'Customer'
    },

    profile: {
        user_name: '',
        password: '',
        password_confirmation: '',
        customer: {
            title: '',
            contact: {
                email: '',
                first_name: '',
                last_name: '',
            }
        },
        address: {
            primary: {
                line1: '',
                region_id: '',
                country_id: '',
                city: '',
                zip_post_code: '',
            },
            secondary: {
                line1: '',
                region_id: '',
                country_id: '',
                city: '',
                zip_post_code: '',
            }
        },
        component_name: 'Customer'
    },
    // customer: {
    //     email: '',
    //     user_name: '',
    //     password: '',
    //     password_confirmation: '',
    //     first_name: '',
    //     last_name: '',
    //     company: '',
    //     // zip_postal: '',
    //     // stateId: '',
    //     address: {
    //         line1: '',
    //         state_id: '',
    //         country_id: '',
    //         city: '',
    //         zip_post_code: '',
    //     }
    // }
    BRAND_DATA: {
        title: 'Brand test',
        short_code: '1234',
        logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Vector-based_example.svg/588px-Vector-based_example.svg.png",
        product_attributes: {
            product_one: {
                title: 'product one',
                db_column: 'product_one',
                show_on_grid: true,
                grid_label: 'Product Id',
                sample_value: 'product one sample',
                data_type: 'text',
                default_value: 'default',
                editable: false,
                datatype: 'text',
                exportable: false,
                searchable: false,
                is_quantity_attribute: false,
                is_product_key: false,
            },
            product_two: {
                title: 'product two',
                db_column: 'product_two',
                show_on_grid: true,
                grid_label: 'Product Id',
                sample_value: 'product two sample',
                data_type: 'text',
                default_value: 'default',
                editable: false,
                datatype: 'text',
                exportable: false,
                searchable: false,
                is_quantity_attribute: false,
                is_product_key: false,
            },
            product_three: {
                title: 'product three',
                db_column: 'product_three',
                show_on_grid: true,
                grid_label: 'Product Id',
                sample_value: 'product three sample',
                data_type: 'text',
                default_value: 'default',
                editable: false,
                datatype: 'text',
                exportable: false,
                searchable: false,
                is_quantity_attribute: false,
                is_product_key: false,
            },
            product_four: {
                title: 'product four',
                db_column: 'product_four',
                show_on_grid: true,
                grid_label: 'Product Id',
                sample_value: 'product four sample',
                data_type: 'text',
                default_value: 'default',
                editable: false,
                datatype: 'text',
                exportable: false,
                searchable: false,
                is_quantity_attribute: false,
                is_product_key: false,
            },
            product_five: {
                title: 'product five',
                db_column: 'product_five',
                show_on_grid: true,
                grid_label: 'Product Id',
                sample_value: 'product five sample',
                data_type: 'text',
                default_value: 'default',
                editable: false,
                datatype: 'text',
                exportable: false,
                searchable: false,
                is_quantity_attribute: false,
                is_product_key: false,
            },
        },
    },
    PRODUCTS_DATA: {
        current_page: 1,
        data: [
            {
                id: 1,
                product_one: 'product one text one',
                product_two: 'product two text one',
                product_three: 'product three text one',
                product_four: 'product four text one',
                product_five: 'product five text one',
            },
            {
                id: 2,
                product_one: 'product one text two',
                product_two: 'product two text two',
                product_three: 'product three text two',
                product_four: 'product four text two',
                product_five: 'product five text two',
            },
            {
                id: 3,
                product_one: 'product one text three',
                product_two: 'product two text three',
                product_three: 'product three text three',
                product_four: 'product four text three',
                product_five: 'product five text three',
            },
            {
                id: 4,
                product_one: 'product one text four',
                product_two: 'product two text four',
                product_three: 'product three text four',
                product_four: 'product four text four',
                product_five: 'product five text four',
            },
            {
                id: 5,
                product_one: 'product one text five',
                product_two: 'product two text five',
                product_three: 'product three text five',
                product_four: 'product four text five',
                product_five: 'product five text five',
            }
        ],
        first_page_url: "http://localhost:8000/api/example?page=1",
        from: 1,
        last_page: 1,
        last_page_url: "http://localhost:8000/api/example?page=1",
        next_page_url: null,
        path: "http://localhost:8000/api/example",
        per_page: "20",
        prev_page_url: null,
        to: 7,
        total: 7,
    },
    OPENING_PARENTHESIS: [
        {
            value: '',
            label: 'None'
        },
        {
            value: '(',
            label: '('
        },
        {
            value: '((',
            label: '(('
        },
        {
            value: '(((',
            label: '((('
        }
    ],
    CLOSING_PARENTHESIS: [
        {
            value: '',
            label: 'None'
        },
        {
            value: ')',
            label: ')'
        },
        {
            value: '))',
            label: '))'
        },
        {
            value: ')))',
            label: ')))'
        }
    ],
    INT_OPERATORS: [
        {
            value: 'equals to',
            label: 'Equals To'
        },
        {
            value: 'greater than',
            label: 'Greater than'
        },
        {
            value: 'greater than or equal',
            label: 'Greater than or Equals to'
        },
        {
            value: 'less than',
            label: 'Less than'
        },
        {
            value: 'less than or equal',
            label: 'Less than or Equals to'
        },
        {
            value: 'any of',
            label: 'Any of'
        },
    ],
    DATE_OPERATORS: [
        {
            value: 'equals to',
            label: 'Equals To'
        },
        {
            value: 'greater than',
            label: 'Greater than'
        },
        {
            value: 'greater than or equal',
            label: 'Greater than or Equals to'
        },
        {
            value: 'less than',
            label: 'Less than'
        },
        {
            value: 'less than or equal',
            label: 'Less than or Equals to'
        },
        {
            value: 'between',
            label: 'In Between'
        },
    ],
    STRING_OPERATORS: [
        {
            value: 'equals to',
            label: 'Equals To'
        },
        {
            value: 'begins with',
            label: 'Begins With'
        },
        {
            value: 'ends with',
            label: 'Ends With'
        },
        {
            value: 'empty',
            label: 'Empty'
        },
        {
            value: 'contains',
            label: 'Contains'
        },
        {
            value: 'any of',
            label: 'Any of'
        },
    ],
    URL_OPERATORS: [
        {
            value: 'equals to',
            label: 'Equals To'
        },
    ],
    GATES: [
        {
            value: 'none',
            label: 'None',
            isDisabled: false,
        },
        {
            value: 'and',
            label: 'AND',
            isDisabled: false,
        },
        {
            value: 'or',
            label: 'OR',
            isDisabled: false,
        },
    ],
    NONE_GATES: [
        {
            value: 'none',
            label: 'None',
            isDisabled: true,
        },
        {
            value: 'and',
            label: 'AND',
            isDisabled: false,
        },
        {
            value: 'or',
            label: 'OR',
            isDisabled: false,
        },
    ],
    AND_GATES: [
        {
            value: 'none',
            label: 'None',
            isDisabled: false,
        },
        {
            value: 'and',
            label: 'AND',
            isDisabled: true,
        },
        {
            value: 'or',
            label: 'OR',
            isDisabled: false,
        },
    ],
    OR_GATES: [
        {
            value: 'none',
            label: 'None',
            isDisabled: false,
        },
        {
            value: 'and',
            label: 'AND',
            isDisabled: false,
        },
        {
            value: 'or',
            label: 'OR',
            isDisabled: true,
        },
    ],
    RULE_FILTER: [
        {
            apply_not: false,
            parenthesis_start: "",
            param_lookup_table: null,
            param_lookup_table_column: null,
            param_lookup_table_column_title: null,
            param_field_id: "",
            param_field: "",
            param_field_title: "",
            param_static_value: [],
            creatable_value: "",
            parenthesis_end: "",
            logical_operator: "none",
            popupHandler: false,
            date: null,
            static_single_value: '',
            has_error: false,
            operand_attribute_id: null,
            operand_attribute: null,
            operand_attribute_title: null,
            operator_category: "",
            operator: "",
            lookup_filters: [],
            param_type: "",
            param_value: [],
            param_title: ""
        }
    ],
    CONCAT_OBJ: {
        value_type: '',
        value_static: '',
        value_field: '',
        value_field_id: '',
        value_field_title: '',
    }
    ,
    LOOKUP_FILTER: [
        {
            apply_not: false,
            parenthesis_start: "",
            operator_category: "",
            operator: "",
            param_field_id: "",
            param_field: "",
            param_field_title: "",
            param_static_value: [],
            creatable_value: "",
            parenthesis_end: "",
            logical_operator: "none",
            popupHandler: false,
            date: null,
            static_single_value: '',
            has_error: false,
            operand_attribute_id: null,
            operand_attribute: null,
            operand_attribute_title: null,
            param_type: "",
            param_value: [],
        }
    ],
    TARGET_ATTRIBUTE: {
        target_attribute_id: "",
        target_attribute_title: "",
        target_attribute: "",
        // action: "",
        // value_type: '',
        // value_static: '',
        // value_field: '',
        // value_field_id: '',
        // value_search: "",
        actions: [],
        set_value_action: "",
        // search_string_type: "",
        // search_static_value: "",
        // value_lookup_table: '',
        // lookup_table_id: '',
        // value_lookup_table_column: '',
        // lookup_attribute_id: '',
        // search_field: "",
        // search_field_id: "",
        // replace_string_type: '',
        // replace_static_value: "",
        // replace_field: '',
        // replace_field_id: '',
        // search_lookup_table: '',
        // search_lookup_table_column: '',
        // replace_lookup_table: '',
        // replace_lookup_table_column: '',
        set_search_string: '',
        set_replace_string: '',
        // operator_base_type: '',
        // operator_base_static_value: '',
        // operator_base_field: '',
        // operator_operand_type: '',
        // operator_operand_static_value: '',
        // operator_operand_field: '',

        //new Variables for clientside expressions
        [Rules.OPERAND_ONE_ACTION]: '',
        [Rules.OPERAND_ONE_VALUE_TYPE]: '',
        [Rules.OPERAND_ONE_VALUE_STATIC]: '',
        [Rules.OPERAND_ONE_VALUE_FIELD]: '',
        [Rules.OPERAND_ONE_VALUE_FIELD_TITLE]: '',
        [Rules.OPERAND_ONE_VALUE_FIELD_ID]: '',
        [Rules.OPERAND_ONE_LOOKUP_TABLE]: '',
        [Rules.OPERAND_ONE_LOOKUP_TABLE_COLUMN]: '',
        [Rules.OPERAND_ONE_DATE]: null,

        [Rules.OPERAND_TWO_ACTION]: '',
        [Rules.OPERAND_TWO_VALUE_TYPE]: '',
        [Rules.OPERAND_TWO_VALUE_STATIC]: '',
        [Rules.OPERAND_TWO_VALUE_FIELD]: '',
        [Rules.OPERAND_TWO_VALUE_FIELD_TITLE]: '',
        [Rules.OPERAND_TWO_VALUE_FIELD_ID]: '',
        [Rules.OPERAND_TWO_LOOKUP_TABLE]: '',
        [Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN]: '',
        [Rules.OPERAND_TWO_DATE]: null,

    },
    BASE_TARGET_ATTRIBUTE: { // BASE attribute refers to the 2nd row in the url CASE
        //For url case
        // base_type: '',
        // base_field_id: '',
        // base_field: '',
        // base_lookup_table: '',
        // base_lookup_table_column: '',
        // base_static: '',

        [Rules.OPERAND_TWO_ACTION]: '',
        [Rules.OPERAND_TWO_VALUE_TYPE]: '',
        [Rules.OPERAND_TWO_VALUE_STATIC]: '',
        [Rules.OPERAND_TWO_VALUE_FIELD]: '',
        [Rules.OPERAND_TWO_VALUE_FIELD_ID]: '',
        [Rules.OPERAND_TWO_LOOKUP_TABLE]: '',
        [Rules.OPERAND_TWO_LOOKUP_TABLE_COLUMN]: '',
        [Rules.OPERAND_TWO_DATE]: null,
    },
    PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Field',
            isDisabled: false,
        },
        {
            value: 'lookup',
            label: 'Table Lookup',
            isDisabled: false,
        },
    ],
    CONCAT_PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Field',
            isDisabled: false,
        },
        {
            value: 'concatby',
            label: 'Add Html Entity',
            isDisabled: false,
        },
    ],

    LOOKUP_FILTERS_PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Field',
            isDisabled: false,
        },
    ],
    DISABLED_INT_PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Select Field',
            isDisabled: false,
        },
        {
            value: 'lookup',
            label: 'Table Lookup',
            isDisabled: false,
        },

    ],
    DISABLED_DATE_PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Select Field',
            isDisabled: false,
        },
        {
            value: 'lookup',
            label: 'Table Lookup',
            isDisabled: false,
        },
    ],
    TARGET_PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'lookup',
            label: 'Table Lookup',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Select Field',
            isDisabled: false,
        },
        {
            value: 'concatby',
            label: 'Add Html Entity',
            isDisabled: false,
        },
    ],
    DISABLED_TARGET_PARAM_TYPES: [
        {
            value: 'static',
            label: 'Static Value',
            isDisabled: false,
        },
        {
            value: 'lookup',
            label: 'Table Lookup',
            isDisabled: false,
        },
        {
            value: 'field',
            label: 'Select Field',
            isDisabled: false,
        },
    ],
    TARGET_ATTRIBUTE_ACTIONS_INT: [
        {
            value: 'set',
            label: 'Set Value'
        },
        {
            value: 'add',
            label: 'Add'
        },
        {
            value: 'subtract',
            label: 'Subtract'
        },
        {
            value: 'multiply',
            label: 'Multiply'
        },
        {
            value: 'divide',
            label: 'Divide'
        },
    ],
    TARGET_ATTRIBUTE_ACTIONS_STRING: [
        {
            value: 'set',
            label: 'Set Value'
        },
        {
            value: 'append',
            label: 'Append'
        },
        {
            value: 'prepend',
            label: 'Prepend'
        },
        {
            value: 'replace',
            label: 'Replace'
        },
        {
            value: 'concat',
            label: 'Concat'
        },
    ],
    TARGET_ATTRIBUTE_ACTIONS_DATE: [
        {
            value: 'set',
            label: 'Set Value'
        },
        {
            value: 'add day',
            label: 'Add Day'
        },
        {
            value: 'add month',
            label: 'Add Month',
        },
        {
            value: 'add year',
            label: 'Add Year'
        },
        {
            value: 'subtract day',
            label: 'Subtract Day'
        },
        {
            value: 'subtract month',
            label: 'Subtract Month'
        },
        {
            value: 'subtract year',
            label: 'Subtract Year'
        },
    ],
    TARGET_ATTRIBUTE_ACTIONS_URL: [
        {
            value: 'set',
            label: 'Set Value'
        },
    ],
    DATE_FORMATS: [
        {
            label: 'dd/mm/yy',
            value: 'd/m/y',
        },
        {
            label: 'dd/mm/yyyy',
            value: 'd/m/Y',
        },
        {
            label: 'mm/dd/yy',
            value: 'm/d/y',
        },
        {
            label: 'mm/dd/yyyy',
            value: 'm/d/Y',
        },
        {
            label: 'dd-mm-yy',
            value: 'd-m-y',
        },
        {
            label: 'dd-mm-yyyy',
            value: 'd-m-Y',
        },
        {
            label: 'mm-dd-yy',
            value: 'm-d-y',
        },
        {
            label: 'mm-dd-yyyy',
            value: 'm-d-Y',
        },
        {
            label: 'yyyymmdd',
            value: 'Ymd',
        },
        {
            label: 'yymmdd',
            value: 'ymd',
        },
    ],

    export_attribute: {
        title: '',
        db_column: '',
        attribute_type: '',
        header_label: '',
    },

    CUSTOMER_LIST_OPTIONS: [
        {
            value: 'all',
            label: 'All'
        },
        {
            value: 'true',
            label: 'Active'
        },
        {
            value: 'false',
            label: 'Inactive'
        },
    ],

    ADDRESS: {
        line1: '',
        region_id: '',
        country_id: '',
        city: '',
        zip_post_code: '',
    },
    //
    ORDER_DETAIL_PROP: {
        billing_address: "",
        billing_address_id: '',
        billing_contact: {
            customer_id: '',
            email: "",
            first_name: "",
            last_name: '',
            model: "",
            model_id: '',
            phone: "",
            status: "",
            type: "",
            type_id: "",
        },

        billing_contact_id: "",
        billingaddress: {
            city: "",
            country: "",
            country_id: "",
            created_at: "",
            customer_id: "",
            id: "",
            line1: "",
            line2: "",
            model: "",
            model_id: "",
            region: "",
            region_id: "",
            status: "",
            title: "",
            type: "",
            type_id: "",
            updated_at: "",
            zip_post_code: "",

        },
        brand: "",
        brand_id: "",
        comments: "",
        customer_email: "",
        customer_id: "",
        customer_name: "",
        date_ordered: "",
        id: "",
        instructions: null,
        items_count: "",
        orderAttributes: [],
        order_attributes: [],
        po_number: "",
        print_currency: "",
        print_currency_id: "",
        print_location: "",
        print_location_id: "",
        productAttributes: [],
        product_attributes: "[]",
        ship_account: null,
        ship_date: null,
        ship_title: "",
        shipped_by_user_id: null,
        shipping_address: "",
        shipping_address_id: "",
        shipping_contact: {
            customer_id: '',
            email: "",
            first_name: "",
            last_name: '',
            model: "",
            model_id: '',
            phone: "",
            status: "",
            type: "",
            type_id: "",
        },
        shipping_contact_id: "",
        shippingaddress: {
            city: "",
            country: "",
            country_id: "",
            created_at: "",
            customer_id: "",
            id: "",
            line1: "",
            line2: "",
            model: "",
            model_id: "",
            region: "",
            region_id: "",
            status: "",
            title: "",
            type: "",
            type_id: "",
            updated_at: "",
            zip_post_code: "",
        },
        status: "",
        tag_layout_attributes: "{}",
        tag_layout_id: "",
        tracking_number: "",
        user_email: "",
        user_name: "",
    }
};




// WEBPACK FOOTER //
// ./src/redux/constant/objects-constant.jsx